import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function AddFollowToUserCollection({type, authorObject, author_id, add}) {

    const [message, setMessage] = useState("")
    const [error, setError] = useState("")

    useEffect(() => {
        console.log("AddFollowToUserCollection Ran")
        console.log(author_id, "Author ID", add, "ADD")
        async function addFollowHandler() {
            if (author_id && authorObject && add) {
                try {
                    const userRef = firestore.collection("authors").doc(author_id).collection("following")
                    const data = {
                        autor_data: authorObject
                    }
                    userRef.add(data)
                    setMessage("Added")
                } catch (error) {
                    console.log(error)
                    setError("Error")
                }
            }
        }
        addFollowHandler()

    }, [add, authorObject, author_id])



    return (
        <div>{message && "Added"}</div>
    )
}
export default AddFollowToUserCollection